import type { ReactNode } from 'react'

import { formatPercent } from '@/features/clubs/lib/clubAnalytics'

import S from '../ClubProfileAnalytics.module.scss'

export type MiniBarRowItem = {
  label: string
  icon?: ReactNode
  percent: number
  count: number
  active?: boolean
}

interface MiniBarRowProps {
  item: MiniBarRowItem
}

const MiniBarRow = ({ item }: MiniBarRowProps) => {
  const percentText = formatPercent(item.percent)

  return (
    <div className={S.miniChartRow}>
      <span className={S.miniChartLabel} title={item.label}>
        {item.icon}
        {item.label}
      </span>
      <div className={S.miniChartBar} aria-hidden>
        <div
          className={`${S.miniChartFill} ${
            item.active ? S.miniChartFillActive : ''
          }`}
          style={{ width: `${Math.min(100, Math.max(0, item.percent))}%` }}
        />
      </div>
      <span
        className={`${S.miniChartValue} ${
          item.active ? S.miniChartValueActive : ''
        }`}
      >
        <span className={S.miniChartPercent}>{percentText}</span>
        <span className={S.miniChartSlash}>/</span>
        <span className={S.miniChartCount}>{item.count}</span>
      </span>
    </div>
  )
}

export default MiniBarRow
